// src/components/common/ModalWrapper.js
// Updated: 10/20/2025 09:00 AM (Added zIndexClass prop)

import React, { useState, useEffect } from 'react';

// Accept zIndexClass prop, default to 'z-50'
const ModalWrapper = ({ children, onClose, size = 'lg', zIndexClass = 'z-50' }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(true);
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    setTimeout(onClose, 300);
  };

  const sizeClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
    '4xl': 'max-w-4xl',
    '5xl': 'max-w-5xl',
  };

  return (
    <div
      // Apply the zIndexClass here
      className={`fixed inset-0 flex justify-center items-center p-4 modal-backdrop ${isOpen ? 'opacity-100' : 'opacity-0'} ${zIndexClass}`}
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
      onClick={handleClose}
    >
      <div
        className={`bg-white rounded-lg shadow-xl w-full flex flex-col modal-content ${sizeClasses[size]} ${isOpen ? 'transform scale-100' : 'transform scale-95'}`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};

export default ModalWrapper;